import { useQuery } from "@tanstack/react-query";
import { GetUser } from "../api/queries";


export const useUser = () => {
    return useQuery({
        queryKey: ['user'],
        queryFn: () => GetUser(),
        staleTime: 60 * 10000 * 30,
        gcTime: 60 * 10000 * 30,
        retry: 1,
    })
}